import { render, staticRenderFns } from "./attachments.template?vue&type=template&id=15f90d16&lang=pug&"
import script from "./attachments.client?vue&type=script&lang=ts&"
export * from "./attachments.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f90d16')) {
      api.createRecord('15f90d16', component.options)
    } else {
      api.reload('15f90d16', component.options)
    }
    module.hot.accept("./attachments.template?vue&type=template&id=15f90d16&lang=pug&", function () {
      api.rerender('15f90d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/attachments/attachments.component.vue"
export default component.exports